var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-costs"},[_c('label',{staticClass:"title"},[_vm._v("Subtotal:")]),_c('div',{staticClass:"val cost"},[_vm._v(_vm._s(_vm.$formatMoney(_vm.subtotal)))])])}
var staticRenderFns = []

export { render, staticRenderFns }